



























import { Component, Vue, Inject, Ref } from 'vue-property-decorator';

import LuogoList from './LuogoList.vue';
import LuogoFilter from './LuogoFilter.vue';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Asl } from '@/data/models/asl.model';
import  LuogoEditModal  from './luogo/LuogoEditModal.vue';
import { BModalComponent } from 'buefy/types/components';
import { cloneDeep } from 'lodash';
@Component({
	components: {
		LuogoList,
		LuogoFilter,
		LuogoEditModal
	},
})
export default class Luoghi extends Vue {
	@Inject('CrudService') crudService!: CrudService<Asl>;

	@Ref('list') list!: LuogoList;
	@Ref('filter') filter!: LuogoFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadData();
	}

	editAsl(item: Asl) {
		this.openAsl(item);
	}

	openAsl(item: Asl) {
		if(!item) {
			item = new Asl();
		} else {
			item = cloneDeep(item);
		}
		const modal = this.$buefy.modal.open({
			parent: this,
			component: LuogoEditModal,
			props: {
				luogo: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Asl) => {
					this.saveAsl(value, modal);
				}
			}
		});
	}

	saveAsl(asl: Asl, modal: BModalComponent) {
		const call = (asl.id) ? this.crudService.saveEntity(Asl, 'asl', asl) : this.crudService.createEntity(Asl, 'asl', asl);

		call.then(() => {
			this.list.loadData();
			this.$buefy.notification.open({
				message: this.$t('luogo-saved').toString(),
				type: 'is-success',
			});
			modal.close();
		})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	deleteAsl(item: Asl) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-asl-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Asl, 'asl', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadData();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}

}
